/**
 * Turn a machine key ("sms_segments", "ai.tokens", "CONTACTS-LIMIT") into a
 * readable label ("Sms Segments", "Ai Tokens", "Contacts Limit"). Used for
 * resource keys, feature keys, and wallet bucket names that have no
 * translation entry.
 */
export function humaniseKey(key: string): string {
    return key
        .replace(/[_.:-]+/g, ' ')
        .trim()
        .split(/\s+/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
